var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('ComponenteCrud',{attrs:{"titulo":"Listado de recetas","datos":_vm.elementos,"tipo":"receta"},on:{"eliminar":_vm.eliminar,"editar":_vm.editar,"nuevo":_vm.nuevo_formulario}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }